/**
 * @generated SignedSource<<12d789aaf1d096359c6c88c989bad2c5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TimeSig = "VALUE_UNSET" | "t12_8" | "t2_2" | "t2_4" | "t3_4" | "t4_4" | "t6_8" | "t9_8" | "%future added value";
export type updateSongTimeSigInput = {
  clientMutationId?: string | null;
  mongoVersion: number;
  songId: string;
  timeSig: TimeSig;
};
export type UpdateSongTimeSigMutation$variables = {
  input: updateSongTimeSigInput;
};
export type UpdateSongTimeSigMutation$data = {
  readonly updateSongTimeSig: {
    readonly errors: ReadonlyArray<{
      readonly __typename: "AuthError";
      readonly message: string;
    }>;
    readonly updatedSong: {
      readonly id: string;
      readonly mongoVersion: number;
      readonly timeSig: TimeSig;
    } | null;
  } | null;
};
export type UpdateSongTimeSigMutation = {
  response: UpdateSongTimeSigMutation$data;
  variables: UpdateSongTimeSigMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "updateSongTimeSigPayload",
    "kind": "LinkedField",
    "name": "updateSongTimeSig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Song",
        "kind": "LinkedField",
        "name": "updatedSong",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeSig",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mongoVersion",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateSongTimeSigMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateSongTimeSigMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4f69cd0d817ca6b4fc2c560fec0ac906",
    "id": null,
    "metadata": {},
    "name": "UpdateSongTimeSigMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateSongTimeSigMutation(\n  $input: updateSongTimeSigInput!\n) {\n  updateSongTimeSig(input: $input) {\n    updatedSong {\n      id\n      timeSig\n      mongoVersion\n    }\n    errors {\n      __typename\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "feba1bd2c281b5b0918ca986f9f12cb6";

export default node;
